module.exports = __webpack_public_path__ + "img/profile.f942a6c2.svg";